import type { BaremetalServer } from '@/entities/baremetal';
import request from '@/shared/api/request';

export const renameBaremetalServer = (
  id: number,
  name: string,
): Promise<{ baremetal: BaremetalServer }> =>
  request({
    url: `/baremetals/${id}/`,
    method: 'POST',
    data: { name, action: 'rename' },
  });
